const e = {
  add: "Adicionar",
  cancel: "Cancelar",
  clear: "Limpar",
  confirm: "Confirmar",
  delete: "Eliminar",
  redo: "Refazer",
  save: "Guardar",
  saveAs: "Guardar como",
  undo: "Anular"
}, a = {
  completed: "Completed",
  notCompleted: "Not completed",
  progressSteps: "Progress steps",
  stepOf: "Step {0} of {1}",
  percentComplete: "{0}{1} complete. Step {2} of {3}"
}, o = {
  cancel: "Cancelar",
  confirm: "Confirmar",
  datePlaceholder: "Selecionar data",
  datetimePlaceholder: "Selecionar data e hora",
  endDatePlaceholder: "Data de fim",
  endDatetimePlaceholder: "Data e hora de fim",
  endMonthPlaceholder: "Fim do Mês",
  monthPlaceholder: "Selecionar mês",
  now: "Agora",
  quarterPlaceholder: "Selecione o Trimestre",
  selectDate: "Selecionar data",
  selectTime: "Selecionar hora",
  startDatePlaceholder: "Data de início",
  startDatetimePlaceholder: "Data e hora de início",
  startMonthPlaceholder: "Mês de Início",
  today: "Hoje",
  weekPlaceholder: "Selecionar semana",
  yearPlaceholder: "Selecionar ano",
  chooseDateAriaLabel: "Choose Date",
  backToDateSelectionAriaLabel: "Back to Date Selection"
}, r = {
  placeholder: "Selecione"
}, t = {
  clear: "Limpar",
  negativeText: "Cancelar",
  now: "Agora",
  placeholder: "Selecionar hora",
  positiveText: "OK"
}, l = {
  placeholder: "Introduza"
}, n = {
  placeholder: "Introduza"
}, s = {
  placeholder: "Comece a escrever..."
}, c = {
  allRows: "Todas as filas",
  default: "Predefinição",
  deleteLayoutDescription: "Tem a certeza de que pretende eliminar este esquema?",
  discardChanges: "Descartar alterações",
  discardLayoutChanges: "Descartar alterações do esquema",
  enterLayoutName: "Introduza o nome do esquema",
  enterRowNumber: "Introduza o número de linhas",
  fieldsSelected: "campos selecionados",
  freezeColumnDescription: "Congele a coluna à esquerda",
  freezeUptoColumn: "Congele até à coluna",
  frozen: "Congelado",
  layoutName: "Nome do esquema",
  manageColumns: "Gerir colunas",
  none: "Nenhum",
  reorderRows: "Reordenar Linhas",
  rowsSelected: "linhas selecionadas",
  saveLayoutAs: "Guardar esquema como",
  saveLayoutNew: "Guardar o novo esquema",
  search: "Pesquisar",
  searchColumnsPlaceholder: "Pesquisar colunas",
  searchFieldsPlaceholder: "Campos de pesquisa",
  selectAll: "Selecionar tudo",
  setTableHeight: "Definir altura da tabela",
  unfreeze: "Descongelar",
  unsavedChanges: "Tem alterações não guardadas",
  unsavedChangesDescription: "Pode haver uma ou mais alterações não guardadas. Pretende guardá-las?"
}, d = {
  at: "em",
  colorAlreadyUsed: "Selecione uma cor diferente ou utilize a atual",
  colorNamePlaceholder: "Introduzir nome",
  customPlaceholder: "{{ Custom }}",
  nameAlreadyUsed: "Selecione um nome de cor diferente",
  noColorsAdded: "Não tem nenhuma cor nesta secção."
}, i = {
  searchPlaceholder: "Pesquisar"
}, u = {
  invalidPastedData: "Dados colados inválidos"
}, m = {
  of: "de",
  page: "Página",
  rowsPerPage: "Linhas por página"
}, p = {
  failedToUpload: "Falha ao carregar",
  retry: "Repetir",
  clickToUpload: "clicar para Carregar",
  orDragAndDrop: "Ou Arrastar e soltar",
  supportedFileTypes: "Tipos de Ficheiro suportados:"
}, h = {
  global: e,
  Progress: a,
  DatePicker: o,
  Select: r,
  TimePicker: t,
  Input: l,
  InputNumber: n,
  InputTag: s,
  HLDataTable: c,
  ColorPicker: d,
  InputPhone: i,
  InputOtp: u,
  Pagination: m,
  Upload: p
};
export {
  d as ColorPicker,
  o as DatePicker,
  c as HLDataTable,
  l as Input,
  n as InputNumber,
  u as InputOtp,
  i as InputPhone,
  s as InputTag,
  m as Pagination,
  a as Progress,
  r as Select,
  t as TimePicker,
  p as Upload,
  h as default,
  e as global
};
